'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onArrive = onArrive;
exports.clearAll = clearAll;
exports.filterType = filterType;
exports.filterKeys = filterKeys;
var Actions = exports.Actions = {
  'ON_ARRIVE': 'ON_ARRIVE',
  'CLEAR': 'CLEAR',
  'FILTER': 'FILTER',
  'SEARCH': 'SEARCH'
};

function onArrive(request) {
  return function (dispatch) {
    dispatch({
      type: Actions.ON_ARRIVE,
      data: request
    });
  };
}

function clearAll() {
  return function (dispatch) {
    dispatch({
      type: Actions.CLEAR
    });
  };
}

function filterType(type) {
  return function (dispatch) {
    dispatch({
      type: Actions.FILTER,
      data: type
    });
  };
}

function filterKeys(keys) {
  return function (dispatch) {
    dispatch({
      type: Actions.SEARCH,
      keys: keys
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/action.js
// module id = 97
// module chunks = 0